import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, Form, Input, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { ValidPostalCode } from "@payping/utils/validation";
import { DashboardRoutes } from "@/router/constant";
import { useIsLocalDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsLocalDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Business/utils";
import { selectAtom } from "jotai/utils";
import { settingsBusinessAtom } from "../../state";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessPostalCode: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const isLocalDisabled = useIsLocalDisabled();

  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const postalCodeApi = useAppSelector((state) => state.user.localInfo?.postalCode);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("postalCode")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={({ postalCode }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.site.url,
                fieldName: "postalCode",
                fieldValue: postalCode,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ postalCode: mobileFormEditState.postalCode ?? postalCodeApi }}
          >
            <Form.Item
              label={t("postalCode")}
              name="postalCode"
              rules={[
                {
                  validator(_, value): Promise<void> {
                    if (ValidPostalCode(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("error.postalCode")));
                  },
                },
                { message: t("error.requiredForTaxCode", { name: t("postalCode") }), required: true },
              ]}
            >
              <Input disabled={isLocalDisabled} onlyNumbers />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>
            {t("settings.business.instructions.postalCodeAndHomePhoneNumber")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessPostalCode;
